




import { Component, Vue } from "vue-property-decorator";
import { Staff, getOtherStaffs } from "@/api/company-api";
import { getServiceUsers, ServiceUser } from "@/api/service-api";
import InvitableStaffSpec from "@/models/specs/InvitableStaffSpec";

import StaffList from "@/templates/StaffList.vue";
import { StaffTableItem } from "@/components/VStaffTable.vue";

@Component({
  components: {
    StaffList
  }
})
export default class StaffListPage extends Vue {
  query = "";

  select(id: number) {
    const params = { id: String(id) };
    this.$router.push({ name: "staff-edit", params });
  }

  create() {
    this.$router.push({ name: "staff-new" });
  }

  search(query: string) {
    this.query = query;
  }

  private staffs: Staff[] = [];
  private serviceUsers: ServiceUser[] = [];

  private get filteredStaff() {
    // TODO: API側で絞り込んだ方がいい
    if (!this.query) return this.staffs;
    return this.staffs.filter(s => s.name.includes(this.query));
  }

  private get items(): StaffTableItem[] {
    return this.filteredStaff.map(
      s => new StaffTableItem(s, (s as any).company)
    );
  }

  private get invitableSpec() {
    return new InvitableStaffSpec(this.serviceUsers);
  }

  private async created() {
    await this.initServiceUsers();
    await this.initStaffs();
  }

  private async initStaffs() {
    this.staffs = await getOtherStaffs();
  }

  private async initServiceUsers() {
    this.serviceUsers = await getServiceUsers();
  }
}
